import { render, staticRenderFns } from "./tyerror.vue?vue&type=template&id=731d6a18"
import script from "./tyerror.vue?vue&type=script&lang=js"
export * from "./tyerror.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('731d6a18')) {
      api.createRecord('731d6a18', component.options)
    } else {
      api.reload('731d6a18', component.options)
    }
    module.hot.accept("./tyerror.vue?vue&type=template&id=731d6a18", function () {
      api.rerender('731d6a18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/tyerror.vue"
export default component.exports